import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { notifyPdfLoadedSection } from '../../../PDFRenderer/PDFRendererActions';
import { PdfSectionType } from '../../../PDFRenderer/PDFRendererTypes';
import { MonteCarloPercentilesDTO } from '../types/monteCarlo.types';
import { queryKeys } from './queryKeys';

const fetchMarketScenarios = async (
  clientId: number,
  fpId: string | null,
  signal?: AbortSignal,
): Promise<MonteCarloPercentilesDTO> => {
  return authFetch(
    urlWithParams('/Consumer/MC/Percentiles', {
      clientId,
      fpId,
    }),
    { signal },
  );
};

interface UseMarketScenariosQueryParams {
  clientId: number;
  fpId: string;
  enabled?: boolean;
}

export const useMarketScenariosQuery = ({
  clientId,
  fpId,
  enabled = true,
}: UseMarketScenariosQueryParams) => {
  const dispatch = useDispatch();

  return useQuery(
    queryKeys.marketScenarios(clientId, fpId),

    ({ signal }) => fetchMarketScenarios(clientId, fpId, signal),
    {
      enabled,
      onSuccess() {
        dispatch(notifyPdfLoadedSection(PdfSectionType.RetirementMarketScenarios));
      },
    },
  );
};
